/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Csv_Deep_P3Inputs */

const en_to_csv_deep_p3 = /** @type {(inputs: To_Csv_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both are easy to work around. If Excel garbles accented or CJK text, import the file through the Data then From Text dialog and select UTF-8 explicitly instead of double clicking it, or prepend a byte order mark with a text editor. Google Sheets and LibreOffice both detect UTF-8 correctly and need neither workaround.`)
};

const ko_to_csv_deep_p3 = /** @type {(inputs: To_Csv_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`둘 다 우회하기 쉽습니다. Excel이 악센트 문자나 한글, 한자를 깨뜨리면 파일을 두 번 클릭하지 말고 데이터 다음 텍스트에서 대화상자로 가져와 UTF-8을 명시적으로 선택하거나, 텍스트 에디터로 바이트 순서 표시를 앞에 붙이세요. Google Sheets와 LibreOffice는 둘 다 UTF-8을 올바르게 감지하므로 어느 우회도 필요하지 않습니다.`)
};

const ja_to_csv_deep_p3 = /** @type {(inputs: To_Csv_Deep_P3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どちらも回避は簡単です。Excel がアクセント付き文字や日本語を壊すなら、ダブルクリックせずにデータからテキストまたは CSV からのダイアログで取り込み、UTF-8 を明示的に選ぶか、テキストエディタでバイトオーダーマークを先頭に付けてください。Google スプレッドシートと LibreOffice はどちらも UTF-8 を正しく判定するので、どちらの回避も不要です。`)
};

/**
* | output |
* | --- |
* | "Both are easy to work around. If Excel garbles accented or CJK text, import the file through the Data then From Text dialog and select UTF-8 explicitly inste..." |
*
* @param {To_Csv_Deep_P3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_csv_deep_p3 = /** @type {((inputs?: To_Csv_Deep_P3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Csv_Deep_P3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_csv_deep_p3(inputs)
	if (locale === "ko") return ko_to_csv_deep_p3(inputs)
	return ja_to_csv_deep_p3(inputs)
});